<div class="onboarding-section" [ngSwitch]="currentStep">
    <cygov-welcome-message (nextButtonClick)="nextStep($event)"
        *ngSwitchCase="'welcome-message'"></cygov-welcome-message>
    <cygov-client-form (nextButtonClick)="nextStep($event)" [wizardData]="wizardData"
        *ngSwitchCase="'client-form'"></cygov-client-form>
    <cygov-welcome-video (nextButtonClick)="nextStep($event)"
        *ngSwitchCase="'welcome-video'" [wizardData]="wizardData"></cygov-welcome-video>
</div>